import { initialPlaycastData, PlaycastData } from './types';
import { PlaycastVector } from '@playcastdotio/CoreTypes';
import { captureStore } from '@playcastdotio/InputCapture';
import { sendMetricPlayerChangeRole } from '../../metrics';
import { playerConnectionState } from '../../api/stores/playerStores';

const refreshed = new Event('playcastDataRefreshed');
const videoDimensionsUpdated = new Event('playcastVideoDimensionsUpdated');
const dataConnectionChanged = new CustomEvent('playcastDataConnectionChanged');
const mediaConnectionChanged = new CustomEvent('playcastMediaConnectionChanged');

const playcastData: PlaycastData = structuredClone(initialPlaycastData);
const userAgent = navigator.userAgent.toLowerCase();
playcastData.device = {
  userAgent: userAgent,
  isMobile: /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent),
  isTablet: /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent),
  isDesktop: !/iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent),
};

const getData = () => {
  return playcastData;
};

const updateVideoDimensions = (dimensions: PlaycastVector) => {
  playcastData.video.dimensions = { ...dimensions };
  dispatchEvent(refreshed);
  dispatchEvent(videoDimensionsUpdated);
};

const updatePlayerOptionsOpen = (open: boolean) => {
  playcastData.options.open = open;
  updatePlayerMobileGamepad(true);
  dispatchEvent(refreshed);
};

const updateGamepadMode = () => {
  playcastData.mode.useGamepadAsMouse = !playcastData.mode.useGamepadAsMouse;
  dispatchEvent(refreshed);
};

const playerModeAllowed = (): boolean => {
  const access = captureStore.getAccess();
  return !!(access.gamepad || access.keyboard || access.mouse || access.touch);
};

let cachedPlayerMode = '';

const updatePlayerMode = (mode: 'spectator' | 'player') => {
  if (playerConnectionState.currentState?.status !== 'connected') return;
  console.log(mode);
  console.log(playerModeAllowed());
  if (mode !== cachedPlayerMode) {
    sendMetricPlayerChangeRole(mode);
  }
  cachedPlayerMode = mode;
  playcastData.mode.mode = mode;
  if (mode === 'player') playcastData.options.open = false;
  if (mode === 'spectator' && playerModeAllowed()) {
    playcastData.options.open = true;
  }
  updatePlayerMobileGamepad(true);
  dispatchEvent(refreshed);
};

const shouldShowMobileGamepad = (): boolean => {
  const access = captureStore.getAccess();
  if (playcastData.device.isMobile || playcastData.device.isTablet) {
    console.log('ismobile or istablet - in shouldShowMobileGamepad');
    if (access.gamepad) {
      console.log('gamepad access - in shouldShowMobileGamepad');
      if (playcastData.mode.mode === 'player') {
        console.log('player mode - in shouldShowMobileGamepad');
        if (playcastData.gamepad.gamepads.filter((g) => !!g).length === 0) {
          console.log('no gamepads - in shouldShowMobileGamepad');
          return true;
        }
      }
    }
  }
  return false;
};

const isPhysicalGamepadConnected = (): boolean => {
  return playcastData.gamepad.gamepads.filter((g) => !!g).length > 0;
};

const updatePlayerMobileGamepad = (skipRefresh?: boolean) => {
  playcastData.mode.useMobileGamepad = shouldShowMobileGamepad();
  if (!skipRefresh) dispatchEvent(refreshed);
};

export const store = {
  getData,
  refreshed,
  videoDimensionsUpdated,
  dataConnectionChanged,
  mediaConnectionChanged,
  updateVideoDimensions,
  updatePlayerOptionsOpen,
  playerModeAllowed,
  updatePlayerMode,
  updatePlayerMobileGamepad,
  isPhysicalGamepadConnected,
  updateGamepadMode,
};
